import formStyles from './Form.module.scss';

const MandatoryFormFieldHint = (): JSX.Element => {
    return <div className={formStyles._mandatoryFieldText}>* Pflichtfelder</div>;
};

export default MandatoryFormFieldHint;
